import React from "react";

type OperationsContextType = {};

const defaultValue: OperationsContextType = {};

export const OperationsContext = React.createContext(defaultValue);

export default function OperationsContextProvider(props: {
  children: React.ReactNode;
}) {
  return (
    <OperationsContext.Provider value={{}}>{props.children}</OperationsContext.Provider>
  );
}
